import { render } from "./Gauge.vue?vue&type=template&id=da374fb2"
import script from "./Gauge.vue?vue&type=script&lang=js"
export * from "./Gauge.vue?vue&type=script&lang=js"
script.render = render

export default script